import { mapState } from "vuex";

/**
 * General-purpose permission checks for gating UI.
 * Self-contained: maps `permissions` from Vuex state, so host components
 * do not need to map it themselves.
 *
 * Permissions follow the `scope:action:resource` convention,
 * e.g. "programs:write:defaults", "admin:manage:clients".
 *
 * Usage:
 *   import permissionsMixin from "@/mixins/permissionsMixin";
 *   export default { mixins: [permissionsMixin] };
 *
 *   <Button v-if="hasPermission('programs:write:defaults')" />
 *   <Panel v-if="hasAnyPermission(['admin:read:clients', 'admin:manage:clients'])" />
 *
 * Note: this only hides UI — it is not a security boundary. Always enforce
 * the same permission on the backend for any API call the UI triggers.
 */
export default {
  computed: {
    ...mapState(["permissions"]),
  },
  methods: {
    hasPermission(permission) {
      return this.permissions?.includes(permission) ?? false;
    },
    hasAnyPermission(permissionList = []) {
      return permissionList.some((permission) => this.hasPermission(permission));
    },
    hasAllPermissions(permissionList = []) {
      return permissionList.every((permission) => this.hasPermission(permission));
    },
  },
};
